<form class="card faturamento-card-form d-flex direction-column" [formGroup]="lotsForm">
  <div class="card-content content d-flex align-center">
    <ng-content select="[cardFlag]"></ng-content>

    <div class="content-checkbox flex-2">
      <app-svg-icon src="../../../../assets/icons/status-repasse.svg"
                    width="20px"
                    height="20px"
                    [ativo]="lote.Active!"
                    color="">
      </app-svg-icon>
    </div>

    <div class="data-group group flex-4">
      <span class="field-label">Lote</span>
      <span class="group-data data">
        <strong class="data-emphasis"> </strong>{{ lote.BatchNumber || '-' }}
      </span>
    </div>

    <div class="data-group group flex-3">
      <span class="field-label">Tipo de Operação</span>
      <span class="group-data data">
        {{ lote.OperationType }}
      </span>
    </div>

    <div class="data-group group flex-3">
      <span class="field-label">BPO/Regional</span>
      <span class="group-data data">
        {{ lote.Bpo }}
      </span>
    </div>

    <div class="data-group group flex-4">
      <span class="field-label">Data do Lote</span>
      <span class="group-data data">
        {{ lote.CreateDate ? (lote.CreateDate | systemDate : 'dd/MM/yyyy') : '-' }}
      </span>
    </div>

    <div class="data-group group flex-4">
      <span class="field-label">Data de Recebimento</span>
      <span class="group-data data">
        {{ (lote.PaymentDate | date : 'dd/MM/yyyy') || '-' }}
      </span>
    </div>

    <div class="data-group group flex-4">
      <span class="field-label">Data de envio e-mail</span>
      <span class="group-data data">
        {{ (lote.EmailInvoiceDate | systemDate : 'dd/MM/yyyy') || '-' }}
      </span>
    </div>

    <div class="data-group group flex-4">
      <span class="field-label">Banco</span>
      <span class="group-data data">{{ lote.Bank || '-' }}</span>
    </div>

    <div class="data-group group flex-4">
      <span class="field-label">Valor Faturado</span>
      <span class="group-data data">
        {{ (lote.AmountTotal | currency : 'BRL') || '-' }}
      </span>
    </div>

    <div class="data-group group flex-4">
      <span class="field-label">Qt. de Contratos</span>
      <span class="group-data data">{{ lote.NumberOfContracts || '-' }}</span>
    </div>

    <div class="data-group group flex-4 status-column">
      <span class="field-label">Status Faturamento</span>
      <app-status-badge [label]="statusLabel" [tone]="statusTone" variant="outline"></app-status-badge>
      <div class="sap-error" *ngIf="lote.IntegrationError" [matTooltip]="lote.IntegrationMsg!">!</div>
    </div>

    <div class="content-btn d-flex flex-1">
      <button type="button"
              class="card-btn d-flex align-center justify-center"
              (click)="routeToDetails(lote.BatchId.toString())">
        <app-svg-icon src="assets/icons/edit-icon.svg"
                      width="12px"
                      color="white"></app-svg-icon>
      </button>
    </div>
  </div>
</form>